<script setup lang="ts">
import {onBeforeMount, useTemplateRef} from "vue";
import {type FilterDisplayParams} from "ag-grid-community";
import QuestionListPanel from "@/components/questionFields/widgets/QuestionListPanel.vue";
import {type QuestionListFilterModel, useQuestionListFilter} from "@/components/questionFields/widgets/useQuestionListFilter.ts";
import {useResizableFilterPopup} from "@/components/inputs/useResizableFilterPopup.ts";
import FieldMetaData = namaTypes.FieldMetaData;

const props = defineProps<{ params: FilterDisplayParams }>();

const columnMetaData = props.params['metaData'] as FieldMetaData;
const entityType = (props.params['entityType'] as string) ?? '';
const queriedClass = props.params['queriedClass'] as string | undefined;
const colId = props.params.colDef?.colId ?? columnMetaData?.fieldId ?? '';
const fieldTitle = props.params.colDef?.headerName ?? '';
const buildListRequest = props.params['context']?.['buildDistinctValuesListRequest'] as ((excludeColId: string) => namaTypes.AGGridListRequest | undefined) | undefined;

const {
  items, isLoading, searchText, selectAllState,
  isItemSelected, toggleAll, toggleItem, applyExternalModel, loadDistinctValues,
} = useQuestionListFilter({
  entityType,
  colId,
  fieldType: columnMetaData?.fieldType,
  referenceTo: columnMetaData?.referencedEntityType,
  queriedClass,
  initialModel: props.params.model,
  getListRequest: buildListRequest ? () => buildListRequest(colId) : undefined,
  onChange: (model) => props.params.onModelChange(model),
});

const rootRef = useTemplateRef<HTMLElement>("rootRef");
useResizableFilterPopup(() => rootRef.value);

onBeforeMount(() => loadDistinctValues());

function refresh(newParams: FilterDisplayParams) {
  applyExternalModel((newParams?.model as QuestionListFilterModel | null) ?? null);
}

defineExpose({refresh});
</script>

<template>
  <div ref="rootRef" class="tw-flex tw-flex-col tw-gap-0.5 tw-rounded tw-p-1 tw-min-w-[260px] tw-w-full tw-h-full ag-custom-component-popup">
    <QuestionListPanel
      v-model:searchText="searchText"
      :items="items"
      :is-loading="isLoading"
      :select-all-state="selectAllState"
      :is-item-selected="isItemSelected"
      :field-title="fieldTitle"
      @toggle-all="toggleAll"
      @toggle-item="toggleItem"/>
  </div>
</template>

<style scoped>
</style>
